/* Solo el contenido del documento legal. El navbar + footer los aporta PageLayout. */
.wrap {
  width: 100%;
  max-width: var(--container-narrow);
  margin: 0 auto;
  padding: var(--space-12) var(--space-6) var(--space-20);
}

.title {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-4xl);
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin-bottom: var(--space-2);
}

.updated {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  margin-bottom: var(--space-10);
}

.roleSection {
  margin-bottom: var(--space-12);
}

.roleTitle {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-2xl);
  letter-spacing: -0.01em;
  color: var(--color-primary);
  padding-bottom: var(--space-3);
  margin-bottom: var(--space-6);
  border-bottom: 1px solid var(--color-border);
}

.section {
  margin-bottom: var(--space-8);
}

.heading {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--text-lg);
  color: var(--color-text);
  margin-bottom: var(--space-3);
}

.body {
  /* Los bullets del texto vienen separados por "\n" → respetamos los saltos. */
  white-space: pre-line;
  color: var(--color-text);
  font-size: var(--text-base);
  line-height: 1.7;
}

@media (max-width: 640px) {
  .wrap {
    padding: var(--space-8) var(--space-4) var(--space-16);
  }

  .title {
    font-size: var(--text-3xl);
  }
}
